import { useMemo } from 'react';
import { CustomFieldType } from '../../components/CustomField/CustomField.type';
import { baseAgentFormSystemFieldKeyList } from '../../constants/forms/ticketFormFields';
import { CustomFieldOption, IFieldDefinition, customSWRConfig } from '../../model/types';
import useConditionOptions from '../../utils/useConditionOptions';
import useAgentFormById from './useAgentFormById';
import useTicketFieldDefinitionList, { getUIFriendlyTicketFieldDefinitionList } from './useTicketFieldDefinitionList';

// in case of missing, we need to add the base agent system fields
const addBaseAgentFormSystemFieldKeys = (fieldKeyList: string[] = []): string[] => [
    ...new Set([...baseAgentFormSystemFieldKeyList, ...fieldKeyList])
];

const collateFieldKeyList = (fieldKeyList: string[]): string[] => {
    // if (!fieldKeyList) {
    //     console.debug('collateFieldKeyList, fieldKeyList is empty');
    // }
    return addBaseAgentFormSystemFieldKeys(fieldKeyList);
};

function refactorFieldOptions<T extends Record<string, any>>(fieldDefinition: {
    type?: CustomFieldType;
    options?: CustomFieldOption[];
}): T {
    if (!fieldDefinition) return fieldDefinition as T;
    const { type } = fieldDefinition;
    if (type === 'SELECT' || type === 'MULTI_SELECT') {
        //TODO: we dont need options any more, we are using suggestions instead of options
        // const sortedOptions = [...options.sort((a, b) => a.order - b.order)];
        return {
            ...fieldDefinition,
            options: []
            // options: sortedOptions.map((option) => ({
            //     ...option,
            //     value: option?.id?.toString() ?? option.value
            // }))
        } as unknown as T;
    }

    return fieldDefinition as T;
}

export default function useFieldDefinitionListFromAgentForm(
    formId: number,
    config: customSWRConfig = {}
): IFieldDefinition[] {
    const { data } = useTicketFieldDefinitionList(true, config);
    const currentAgentForm = useAgentFormById(formId, config);
    const { localizeOptions } = useConditionOptions();

    const fields = useMemo(() => {
        const fieldListObject = getUIFriendlyTicketFieldDefinitionList(data);

        return collateFieldKeyList(currentAgentForm?.fields?.map(({ key }) => key))
            ?.reduce(
                (acc, fieldKey) =>
                    fieldListObject.listMap && fieldKey in fieldListObject.listMap
                        ? [...acc, refactorFieldOptions<IFieldDefinition>(fieldListObject.listMap[fieldKey])]
                        : acc,
                []
            )
            ?.map((field: IFieldDefinition) => ({
                ...field,
                options: localizeOptions(field.key as any, field.options)
            }));
    }, [currentAgentForm, data, localizeOptions]);

    return fields;
}

export { refactorFieldOptions };
